import { Route, Routes } from "react-router-dom";
import MyFolders from "../../app/my-folders";

export default function MyFoldersRoutes() {
  return (
    <Routes>
      <Route path="/" element={<MyFolders />} />
    </Routes>
  );
}
